import type { User } from "@titancloud/shared";
import { UserRow } from "./UserRow";
import { UserCard } from "./UserCard";

interface UserTableProps {
  users: User[];
  onRefresh: () => void;
}

export function UserTable({ users, onRefresh }: UserTableProps) {
  if (users.length === 0) {
    return <p className="py-8 text-center text-sm text-gray-500">No users found</p>;
  }

  return (
    <>
      {/* Desktop table */}
      <div className="hidden overflow-x-auto md:block">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-700 text-xs font-medium text-gray-500 uppercase tracking-wide">
              <th className="px-6 py-3 text-left">User</th>
              <th className="px-4 py-3 text-left">Status</th>
              <th className="px-4 py-3 text-left">Storage</th>
              <th className="px-4 py-3 text-left">Quota <span className="normal-case text-gray-600 font-normal">(click to edit)</span></th>
              <th className="px-4 py-3 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <UserRow key={user.id} user={user} onUpdated={onRefresh} />
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="space-y-3 p-4 md:hidden">
        {users.map((user) => (
          <UserCard key={user.id} user={user} onUpdated={onRefresh} />
        ))}
      </div>
    </>
  );
}
